export default __webpack_public_path__ + "static/media/133.ab281624.png";